/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import React, { Suspense } from "react";
import {
  RankedTester,
  rankWith,
  RendererProps,
  uiTypeIs,
} from "@jsonforms/core";
import { withJsonFormsLayoutProps } from "@jsonforms/react";

// Lodash
import { get } from "lodash";

// Redux
import { useSelector } from "react-redux";

// Utils
import { evaluateContextRule, extractPath } from "../utils/commonUtils";

import { AllIcons } from "../utils/icons";

export const IconRenderTester: RankedTester = rankWith(4, uiTypeIs("Icon"));

function IconRenderer({ uischema, visible }: RendererProps) {
  const iconName = uischema.options?.iconName;
  const spectrumProps = uischema.options?.spectrumProps;
  let iconJsx = null;

  if (Object.keys(AllIcons).includes(iconName)) {
    const Icon = AllIcons[iconName];
    iconJsx = <Icon {...spectrumProps} />;
  }

  // Determine if the component should be visible
  let componentVisibility = visible;

  // If there is a context rule, evaluate it and use that visibility rule instead.
  if (uischema.options?.contextRule) {
    // grab the scope from the contextRule
    const scope = extractPath(uischema.options?.contextRule?.condition?.scope);
    // get the redux store state based on the scope provided
    const reduxState = useSelector((state: any) =>
      get(state?.reduxState, scope)
    );
    componentVisibility = evaluateContextRule(
      uischema.options?.contextRule,
      reduxState
    )?.visible;
  }

  return (
    <div data-testid={`${iconName}-id`} hidden={!componentVisibility}>
      <Suspense fallback={<div>Page is Loading...</div>}>
        <section>{iconJsx}</section>
      </Suspense>
    </div>
  );
}

export default withJsonFormsLayoutProps(IconRenderer);
